/* eslint-disable @typescript-eslint/no-explicit-any */
import mitt from 'mitt'

export default mitt<any>()
